import { DatePipe } from '@angular/common';
import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { DocumentsType } from '../../../models/_enum-collections';
import { CustomerAcknowledgement } from '../../../models/customer-ack.model';
import { DealAssociationDocument } from '../../../models/deal-association-document.model';
import { DocumentReviewModel } from '../../../models/document-review.model';
import {
  FileContentModel,
  PreviewFileTypes
} from '../../../models/file-content.model';
import { IncentivePreviewInput } from '../../../models/Incentive-preview-input.model';
import { InvoiceRejectReason } from '../../../models/invoice-reject-reason';
import { PoeDocHyperLink } from '../../../models/poe-doc-hyper-link.model';
import {
  PreviewDocumentTypes,
  UpdateCustomerAckDocument
} from '../../../models/update-customer-ack-document.model';
import { PreviewFileComponent } from '../../preview/preview-file/preview-file.component';
import { DashboardService } from '../../services/dashboard.service';
import { OsmosisEditService } from '../../services/osmosis-edit.service';
import { CommonSharedModule } from '../../common/shared.module';

@Component({
  selector: 'app-incentive-preview',
  templateUrl: './incentive-preview.component.html',
  styleUrls: ['./incentive-preview.component.scss'],
  standalone: true,
  imports: [CommonSharedModule, PreviewFileComponent]
})
export class IncentivePreviewComponent implements OnInit {
  @Input() incentivePreviewInput!: IncentivePreviewInput;
  @Output() closePreviewModal = new EventEmitter<boolean>();
  fileContentModel!: FileContentModel;
  isDocumentPreviewLoading = false;
  isCustomerDocumentPreview = false;
  canShowPreviewModel!: boolean;
  customerAck!: CustomerAcknowledgement[];
  downloadSpin = true;
  index = 0;
  engagementIdList!: number[];
  engagementIndex!: number;
  showApproveDeny!: boolean;
  msgsUsageDetails!: any[];
  modalTitle!: string;
  invoiceRejectionList!: InvoiceRejectReason[];
  invoiceRejectionModalDisplay!: boolean;
  @Output() OnPoeDocumentReview: EventEmitter<any> = new EventEmitter<any>();
  datePipe = new DatePipe('en-US');
  formInvoiceRejection!: FormGroup;
  dealAssociationDocument =
    'Microsoft Solution Advisor Incentives_Deal Association Template';
  poeDocHyperLinks!: PoeDocHyperLink[];
  documentUploadedDate!: Date;
  documentStatus!: string;
  poeDetailsForm!: FormGroup;

  constructor(
    private sanitizer: DomSanitizer,
    private previewfile: PreviewFileComponent,
    private osmEdit: OsmosisEditService,
    private dashboardService: DashboardService,
    private formBuilder: FormBuilder
  ) {}
  OnFormGroup() {
    this.formInvoiceRejection = this.formBuilder.group({
      invoiceRejectionReason: [''],
      additionalNotesRejectionReason: ['']
    });
  }
  ngOnInit() {
    this.canShowPreviewModel = true;
    this.engagementIdList = this.incentivePreviewInput.engagementIdList || [];
    this.engagementIndex = this.engagementIdList.indexOf(
      this.incentivePreviewInput.engagementId
    );
    this.showPreview(this.incentivePreviewInput.engagementId);
    this.OnFormGroup();
  }

  showPreview(engagementId) {
    this.canShowPreviewModel = true;
    this.index =
      this.incentivePreviewInput.engagementId === engagementId
        ? this.incentivePreviewInput.previewFileIndex
        : 0;
    this.showApproveDeny = true;
    this.isDocumentPreviewLoading = true;

    this.getIncentiveDetails(engagementId);

    if (
      this.incentivePreviewInput.dealAssociationDocument == undefined ||
      this.incentivePreviewInput.dealAssociationDocument == null
    ) {
      this.getPoeDocumentsForEngagement(engagementId);
    } else {
      this.getUploadedPOEDocs_ByEngagementId(engagementId);
    }
  }

  getPoeDocumentsForEngagement(engagementId) {
    this.osmEdit
      .getPOEDocumentsForEngagementDetail(engagementId)
      .subscribe(response => {
        this.incentivePreviewInput.dealAssociationDocument =
          response.poeDocuments[0];
        this.getUploadedPOEDocs_ByEngagementId(engagementId);
      });
  }

  getIncentiveDetails(engagementId) {
    this.osmEdit
      .getIncentiveDataByRequestDetailsById(engagementId)
      .subscribe(result => {
        this.incentivePreviewInput.engagementId = engagementId;
        this.incentivePreviewInput.incentiveName = result.deliveryName || '';
        this.incentivePreviewInput.customerOrgName =
          result.customerOrgName || '';
        this.incentivePreviewInput.partnerOrgName = result.partnerOrgName || '';
        this.incentivePreviewInput.partnerInputRequestorEmail =
          result.partnerInputRequestorEmail || '';
        this.incentivePreviewInput.committedDate =
          result.workshopCompletionDate || new Date();
        this.incentivePreviewInput.day45ExpirationDate =
          result.day45ExpirationDate;
        this.incentivePreviewInput.incentiveExpirationDate =
          result.incentiveExpirationDate;
      });
  }

  previewFile(engagementId) {
    this.fileContentModel = new FileContentModel();
    let fileContentUrl: string;

    const downloadAcknowledgementInputModel: UpdateCustomerAckDocument = {
      engagementId: engagementId,
      fileName: this.customerAck[this.index].fileName,
      documentType: PreviewDocumentTypes.customerAcknowledgement
    };

    this.dashboardService
      .getPreviewFileContent(downloadAcknowledgementInputModel)
      .subscribe(
        downloadFile => {
          if (
            this.customerAck &&
            this.customerAck[this.index] &&
            this.customerAck[this.index]?.fileName?.endsWith('.pdf')
          ) {
            const file = new Blob([downloadFile], { type: 'application/pdf' });
            fileContentUrl = URL.createObjectURL(file);
            this.fileContentModel.previewFileType = PreviewFileTypes.pdf;
          } else {
            this.fileContentModel.previewFileType = PreviewFileTypes.image;
            const blob = new Blob([downloadFile]);
            const objectURL = URL.createObjectURL(blob);
            fileContentUrl = this.transformURL(objectURL);
          }

          if (fileContentUrl != null) {
            this.fileContentModel.fileFound = true;
            this.fileContentModel.fileUrl = fileContentUrl;
            this.isDocumentPreviewLoading = false;
            this.previewfile.open();
          }
        },
        () => {
          this.isDocumentPreviewLoading = false;
        }
      );
    this.isCustomerDocumentPreview = true;
  }

  transformURL(url: string): any {
    if (!url) {
      return null;
    }
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  getFileDetails(
    downloadAcknowledgementInputModel: UpdateCustomerAckDocument,
    fileContentUrl: string
  ) {
    this.fileContentModel = new FileContentModel();
    this.fileContentModel.fileFound = true;

    const extension = downloadAcknowledgementInputModel.fileName
      ?.split('.')
      ?.pop();

    if (
      extension?.toLowerCase() === 'doc' ||
      extension?.toLowerCase() === 'docx' ||
      extension?.toLowerCase() === 'ppt' ||
      extension?.toLowerCase() === 'pptx'
    ) {
      switch (extension) {
        case 'docx':
        case 'doc': {
          this.fileContentModel.previewFileType = PreviewFileTypes.doc;
          break;
        }
        case 'pptx':
        case 'ppt': {
          this.fileContentModel.previewFileType = PreviewFileTypes.ppt;
          break;
        }
      }
      if (fileContentUrl != null) {
        this.fileContentModel.fileFound = true;
        this.fileContentModel.fileUrl = fileContentUrl;
        this.isDocumentPreviewLoading = false;
        this.previewfile.open();
      }
    } else if (extension?.toLowerCase() === 'pdf') {
      this.dashboardService
        .getPreviewFileContent(downloadAcknowledgementInputModel)
        .subscribe(downloadFile => {
          const file = new Blob([downloadFile], { type: 'application/pdf' });
          fileContentUrl = URL.createObjectURL(file);
          this.fileContentModel.previewFileType = PreviewFileTypes.pdf;
          if (fileContentUrl != null) {
            this.fileContentModel.fileFound = true;
            this.fileContentModel.fileUrl = fileContentUrl;
            this.isDocumentPreviewLoading = false;
            this.previewfile.open();
          }
        });
    } else if (
      extension?.toLowerCase() === 'jpeg' ||
      extension?.toLowerCase() === 'png' ||
      extension?.toLowerCase() === 'jpg' ||
      extension?.toLowerCase() === 'bmp' ||
      extension?.toLowerCase() === 'gif'
    ) {
      this.fileContentModel.previewFileType = PreviewFileTypes.image;
      if (fileContentUrl != null) {
        this.fileContentModel.fileFound = true;
        this.fileContentModel.fileUrl = fileContentUrl;
        this.isDocumentPreviewLoading = false;
        this.previewfile.open();
      }
    } else {
      this.fileContentModel.previewFileType = PreviewFileTypes.unsupported;
      this.fileContentModel.fileFound = true;
      this.fileContentModel.fileUrl = fileContentUrl;
      this.isDocumentPreviewLoading = false;
      this.previewfile.open();
    }
  }

  previewInvoice(invoiceFile: DealAssociationDocument, engagementId: number) {
    const downloadAcknowledgementInputModel: UpdateCustomerAckDocument = {
      engagementId: engagementId,
      fileName: invoiceFile.fileName,
      documentType: PreviewDocumentTypes.poedocument
    };

    this.getFileDetails(
      downloadAcknowledgementInputModel,
      invoiceFile.poeDocFilePath || ''
    );
  }

  closePreview() {
    this.previewfile.close();
    this.canShowPreviewModel = false;
    this.closePreviewModal.emit(false);
  }

  closeDeclineModal() {
    this.invoiceRejectionModalDisplay = false;
    this.formInvoiceRejection.reset();
  }

  checkForPrevious() {
    return !(this.engagementIndex == 0);
  }
  checkForNext() {
    return !(this.engagementIndex == this.engagementIdList.length - 1);
  }

  onPreviousClick() {
    this.previewfile.close();
    this.canShowPreviewModel = false;
    this.isCustomerDocumentPreview = false;
    const engagementId = this.engagementIdList[--this.engagementIndex];
    this.incentivePreviewInput.dealAssociationDocument = undefined;
    this.showPreview(engagementId);
  }

  onNextClick() {
    this.previewfile.close();
    this.canShowPreviewModel = false;
    this.isCustomerDocumentPreview = false;
    const engagementId = this.engagementIdList[++this.engagementIndex];
    this.incentivePreviewInput.dealAssociationDocument = undefined;
    this.showPreview(engagementId);
  }

  submitForApproval() {
    const documentReviewInfo: DocumentReviewModel = {
      requestDetailId: this.incentivePreviewInput.engagementId,
      documentType: this.incentivePreviewInput.documentTypeId,
      isApprove: true,
      reasons: [],
      filePath: ''
    };

    this.reviewPoeDocuments(documentReviewInfo);
  }

  reviewPoeDocuments(documentReviewInfo: DocumentReviewModel) {
    this.osmEdit
      .updateDealAssociationDocumentsReviewStatus(
        documentReviewInfo,
        this.incentivePreviewInput.dealAssociationDocument?.documentType || -1
      )
      .subscribe(
        messageResponse => {
          if (messageResponse.success === true) {
            this.showApproveDeny = false;
            if (documentReviewInfo.isApprove) {
              this.documentStatus = 'Approved';
              this.showMessage('Deal Association document approved!');
            } else {
              this.documentStatus = 'Rejected';
              this.showMessage('Deal Association document rejected!');
            }
            if (documentReviewInfo.isApprove) {
              this.OnPoeDocumentReview.emit(true);
            } else {
              this.OnPoeDocumentReview.emit(false);
            }
          } else {
            this.showMessage('Sorry an error occured');
          }
        },
        error => {
          this.showMessage(error.error.errorInfo, true);
        }
      );
  }

  onDeny() {
    const documentReviewInfo: DocumentReviewModel = {
      requestDetailId: this.incentivePreviewInput.engagementId,
      documentType: DocumentsType.DealAssociationTemplate,
      isApprove: false,
      reasons: [],
      filePath: ''
    };

    if (this.formInvoiceRejection.controls['invoiceRejectionReason'].value) {
      const selectedReasons =
        this.formInvoiceRejection.controls['invoiceRejectionReason'].value;
      selectedReasons.forEach(element => {
        documentReviewInfo.reasons.push(element);
      });
    }
    documentReviewInfo.additionalNotes =
      this.formInvoiceRejection.controls[
        'additionalNotesRejectionReason'
      ].value;

    this.poeDocHyperLinks.forEach(poeDocs => {
      documentReviewInfo.oFactNominationPOEdocumentsId =
        poeDocs.oFactNominationPOEdocumentsId;
    });
    documentReviewInfo.filePath =
      this.incentivePreviewInput.dealAssociationDocument?.poeDocFilePath || '';

    this.reviewPoeDocuments(documentReviewInfo);

    this.closeDeclineModal();
  }

  showMessage(message: string, isError?: boolean) {
    this.msgsUsageDetails = [];
    this.msgsUsageDetails.push({
      severity: !isError ? 'success' : 'error',
      detail: message
    });
  }

  get DocumentsType(): typeof DocumentsType {
    return DocumentsType;
  }

  onDenyOpen() {
    this.invoiceRejectionModalDisplay = true;
    this.getInvoiceRejectionReasonList();
  }

  getInvoiceRejectionReasonList() {
    this.osmEdit
      .getInvoiceRejectionReasonDropDown(DocumentsType.DealAssociationTemplate)
      .subscribe(RejectionReason => {
        this.invoiceRejectionList = RejectionReason;
      });
  }

  getUploadedPOEDocs_ByEngagementId(engagementId: number) {
    this.osmEdit
      .getUploadedPOEDocs_ByEngagementId(engagementId)
      .subscribe(result => {
        this.poeDocHyperLinks = result;

        const doc = this.poeDocHyperLinks.find(
          x => x.poeDocName === this.dealAssociationDocument
        );

        if (doc) {
          doc.documentType =
            this.incentivePreviewInput.dealAssociationDocument?.documentId;
        }
        this.incentivePreviewInput.dealAssociationDocument =
          doc as DealAssociationDocument;
        this.documentStatus = doc?.status || '';
        this.documentUploadedDate = doc?.uploadDate || new Date();

        this.previewInvoice(
          this.incentivePreviewInput.dealAssociationDocument,
          engagementId
        );
      });
  }

  get invoiceDenyButtonEnable(): boolean {
    return (
      this.formInvoiceRejection.controls['invoiceRejectionReason'].value !=
        null &&
      this.formInvoiceRejection.controls['invoiceRejectionReason'].value
        .length > 0
    );
  }
}
